<template>
  <div class="header-container">
    <div :class="['tips', {hide: showCloseStatus}]">
      {{ $t('navList.tips') }}
      <img src="./images/close.png" class="close" @click="close">
    </div>
    <div class="header">
      <img class="logo" src="./images/logo.png"  @click="()=>router.push({ path: '/index' })"/>
      <!-- PC端导航 -->
      <div class="nav">
        <div
          v-for="(list, eq) in navList"
          :key="eq"
          :class="['list', { active: navListIndex === eq }]"
          @click="changeNav(list, eq, 0)">
          {{ list.name }}
          <img src="./images/arrow.svg" class="arrow" alt="arrow" v-if="eq === 2" />
          <div v-if="eq === 2" class="children">
            <div :class="['item', { itemActive: navListChildrenIndex === ind }]" v-for="(item, ind) in list.children" :key="ind" @click.stop.prevent="changeNav(item, ind, 1)">
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      <div class="contact" @click="changeNav({ path: '/contact' }, -1)">
        {{ $t('navList.contact') }}
      </div>
      <img class="language" @click="changeLocale" src="./images/language.svg" alt="language">
      <!-- 响应式右侧区域：语言切换 + 汉堡按钮 -->
      <div class="header-right">
        <img class="mobile-language" @click="changeLocale" src="./images/language.svg" alt="language">
        <div :class="['hamburger', { active: drawerVisible }]" @click="toggleDrawer">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
    <!-- 移动端侧滑抽屉 -->
    <div :class="['drawer-mask', { visible: drawerVisible }]" @click="closeDrawer"></div>
    <div :class="['drawer', { open: drawerVisible }]">
      <div class="drawer-header">
        <img class="drawer-logo" src="./images/logo.png" @click="()=>{ router.push({ path: '/index' }); closeDrawer() }"/>
        <img class="drawer-close" src="./images/close.png" @click="closeDrawer" />
      </div>
      <div class="drawer-nav">
        <template v-for="(list, eq) in navList" :key="eq">
          <div
            :class="['drawer-item', { active: navListIndex === eq }]"
            @click="handleDrawerNav(list, eq, 0)">
            {{ list.name }}
            <img src="./images/arrow.svg" class="drawer-arrow" :class="{ rotate: drawerSubIndex === eq }" v-if="list.children" />
          </div>
          <!-- 子菜单紧跟父级 -->
          <div class="drawer-children" v-if="list.children && drawerSubIndex === eq">
            <div
              :class="['drawer-child-item', { active: navListChildrenIndex === ind }]"
              v-for="(item, ind) in list.children"
              :key="ind"
              @click="handleDrawerNav(item, ind, 1)">
              {{ item.name }}
            </div>
          </div>
        </template>
        <div class="drawer-item" @click="handleDrawerNav({ path: '/contact' }, -1, 0)">
          {{ $t('navList.contact') }}
        </div>
      </div>
      <div class="drawer-footer">
        <div class="drawer-lang" @click="changeLocale">
          <img src="./images/language.svg" alt="language" />
          {{ locale === 'zh' ? 'English' : '中文' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup name="navHeader">
import { ref, watch, onMounted, onUnmounted } from 'vue'
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n()

import { useRouter, useRoute } from 'vue-router'
const router = useRouter()
const route = useRoute()

const navListIndex = ref(0)
const navListChildrenIndex = ref(-1)
const drawerVisible = ref(false)
const drawerSubIndex = ref(-1)
const isMobile = ref(false)

const checkMobile = () => {
  isMobile.value = window.innerWidth < 768
}

onMounted(() => {
  checkMobile()
  window.addEventListener('resize', checkMobile)
})

onUnmounted(() => {
  window.removeEventListener('resize', checkMobile)
})

const navList = ref([
  { name: t('navList.home'), path: "/index" },
  { name: t('navList.compare'), path: "/cooperation" },
  { name: t('navList.intro'), path: "/introduce", children: [
   { name: t('navList.ntn_fa'), path: "/introduce" },
   { name: t('navList.develop'), path: "/develop" },
  ]},
  { name: t('navList.aboutUs'), path: "/about" },
])

const changeLocale = () => {
  locale.value = locale.value === 'zh' ? 'en' : 'zh'
  localStorage.setItem('locale', locale.value)
  navList.value = [
    { name: t('navList.home'), path: "/index" },
    { name: t('navList.compare'), path: "/cooperation" },
    { name: t('navList.intro'), path: "/introduce", children: [
     { name: t('navList.ntn_fa'), path: "/introduce" },
     { name: t('navList.develop'), path: "/develop" },
    ]},
    { name: t('navList.aboutUs'), path: "/about" },
  ]
}

const changeNav = (data, index, type) => {
  if (type === 0) {
    navListIndex.value = index
    navListChildrenIndex.value = -1
  } else {
    navListIndex.value = 2
    navListChildrenIndex.value = index
  }
  router.push(data.path)
}

const toggleDrawer = () => {
  drawerVisible.value = !drawerVisible.value
  if (drawerVisible.value) {
    document.body.style.overflow = 'hidden'
  } else {
    document.body.style.overflow = ''
  }
}

const closeDrawer = () => {
  drawerVisible.value = false
  document.body.style.overflow = ''
}

const handleDrawerNav = (data, index, type) => {
  if (type === 0 && data.children) {
    // 点击有子菜单的项，展开/收起子菜单
    drawerSubIndex.value = drawerSubIndex.value === index ? -1 : index
    return
  }
  if (type === 0) {
    navListIndex.value = index
    navListChildrenIndex.value = -1
    drawerSubIndex.value = -1
  } else {
    navListIndex.value = 2
    navListChildrenIndex.value = index
  }
  router.push(data.path)
  closeDrawer()
}

const showCloseStatus = ref(false)
const close = () => {
  showCloseStatus.value = true
}

watch(route, (val) => {
  if (val.fullPath === `/contact`) return navListIndex.value = -1
  navList.value.forEach((item, index) => {
    if (val.fullPath === '/introduce') {
      navListIndex.value = 2
      navListChildrenIndex.value = 0
      return
    }
    if (val.fullPath === '/NTN') {
      navListIndex.value = 2
      navListChildrenIndex.value = 1
      return
    }
    if (val.fullPath === '/develop') {
      navListIndex.value = 2
      navListChildrenIndex.value = 2
      return
    }
    if (item.path === `${val.fullPath}`) navListIndex.value = index
  })
})
</script>

<style lang="less" scoped>
.header-container {
  width: 100%;
  position: fixed;
  top: 0;
  z-index: 10;
}
.tips {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
  width: 100%;
  height: 40px;
  letter-spacing: 2px;
  transition: height .3s ease;
  background: linear-gradient(to right, #5470fe, #fd66c5);
  position: relative;
  &.hide {
    height: 0;
  }
  .close {
    cursor: pointer;
    width: 16px;
    height: 16px;
    position: absolute;
    top: 0;
    right: 30px;
    bottom: 0;
    margin: auto 0;
  }
}
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 90%;
  min-width: 1280px;
  margin: 0 auto;
  background: #fff;
  .logo {
    width: 140px;
    padding-top: 10px;
  }
  .nav {
    flex: 1;
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    .list {
      color: #333;
      font-size: 16px;
      cursor: pointer;
      height: 50px;
      line-height: 50px;
      margin: 0 0 0 60px;
      border-bottom: 2px solid transparent;
      position: relative;
      &.active {
        color: #2e69ff;
        font-weight: bold;
        &::after {
          content: "";
          width: 100%;
          height: 2px;
          background: #2e69ff;
          position: absolute;
          left: 0;
          bottom: 5px;
        }
      }
      &:hover {
        color: #2e69ff;
        &::after {
          content: "";
          width: 100%;
          height: 2px;
          background: #2e69ff;
          position: absolute;
          left: 0;
          bottom: 5px;
        }
        .arrow {
          transform: rotate(0deg);
        }
        .children {
          display: block;
        }
      }
      .arrow {
        width: 12px;
        margin: 0 0 0 5px;
        transform: rotate(180deg);
        transition: all 0.3s ease;
      }
      .children {
        display: none;
        min-width: 140px;
        border-radius: 6px;
        box-shadow: 0 0 10px #ccc;
        background: #fff;
        position: absolute;
        left: 50%;
        top: 55px;
        transform: translateX(-50%);
        transition: all 0.3s ease;
      }
      .item {
        color: #666;
        font-size: 13px;
        font-weight: normal;
        height: 40px;
        line-height: 40px;
        text-align: center;
        padding: 0 20px;
        white-space: nowrap;
        &.itemActive {
          color: #2e69ff;
        }
      }
    }
  }
  .contact {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 14px;
    cursor: pointer;
    width: 100px;
    height: 36px;
    margin: 0 0 0 50px;
    border-radius: 4px;
    background: #2e69ff;
  }
  .language {
    cursor: pointer;
    width: 24px;
    margin: 0 0 0 30px;
    padding-right: 40px;
  }
  /* 响应式右侧区域 - 默认隐藏 */
  .header-right {
    display: none;
    align-items: center;
    margin-left: auto;
  }
  /* 响应式语言切换按钮 */
  .mobile-language {
    cursor: pointer;
    width: 24px;
    margin-right: 12px;
  }
  /* 汉堡按钮 */
  .hamburger {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 36px;
    height: 36px;
    cursor: pointer;
    gap: 5px;
    span {
      display: block;
      width: 22px;
      height: 2px;
      background: #333;
      border-radius: 2px;
      transition: all 0.3s ease;
    }
    &.active {
      span:nth-child(1) {
        transform: rotate(45deg) translate(5px, 5px);
      }
      span:nth-child(2) {
        opacity: 0;
      }
      span:nth-child(3) {
        transform: rotate(-45deg) translate(5px, -5px);
      }
    }
  }
}

/* 侧滑抽屉 - 默认隐藏 */
.drawer-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.3s ease, visibility 0.3s ease;
  &.visible {
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
  }
}
.drawer {
  position: fixed;
  top: 0;
  right: 0;
  width: 280px;
  height: 100%;
  background: #fff;
  z-index: 100;
  display: flex;
  flex-direction: column;
  transform: translateX(100%);
  transition: transform 0.3s ease;
  &.open {
    transform: translateX(0);
  }
  .drawer-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px 20px;
    border-bottom: 1px solid #eee;
    .drawer-logo {
      width: 100px;
    }
    .drawer-close {
      width: 20px;
      height: 20px;
      cursor: pointer;
    }
  }
  .drawer-nav {
    flex: 1;
    padding: 10px 0;
    overflow-y: auto;
  }
  .drawer-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 20px;
    font-size: 16px;
    color: #333;
    cursor: pointer;
    transition: background 0.2s;
    &.active {
      color: #2e69ff;
      font-weight: bold;
    }
    &:active {
      background: #f5f5f5;
    }
    .drawer-arrow {
      width: 14px;
      transition: transform 0.3s;
      &.rotate {
        transform: rotate(180deg);
      }
    }
  }
  .drawer-children {
    background: #f8f8f9;
    .drawer-child-item {
      padding: 12px 20px 12px 40px;
      font-size: 14px;
      color: #666;
      cursor: pointer;
      &.active {
        color: #2e69ff;
        font-weight: bold;
      }
      &:active {
        background: #eee;
      }
    }
  }
  .drawer-footer {
    padding: 15px 20px;
    border-top: 1px solid #eee;
    .drawer-lang {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 14px;
      color: #333;
      cursor: pointer;
      img {
        width: 20px;
      }
    }
  }
}

/* PC端隐藏抽屉和遮罩 */
.header-right {
  display: none;
}
.drawer-mask,
.drawer {
  display: none;
}

/* ========== iPad 适配 ========== */
@media screen and (max-width: 1279px) {
  .header {
    min-width: auto;
    width: 92%;
    .nav {
      display: none;
    }
    .contact {
      display: none;
    }
    .language {
      display: none;
    }
    .header-right {
      display: flex;
    }
  }
  .drawer-mask,
  .drawer {
    display: block;
  }
  .drawer {
    display: flex;
  }
}

/* ========== 移动端适配 ========== */
@media screen and (max-width: 767px) {
  .tips {
    font-size: 12px;
    height: 32px;
    .close {
      right: 15px;
    }
  }
  .header {
    width: 100%;
    padding: 0 15px;
    box-sizing: border-box;
    .logo {
      width: 100px;
      padding-top: 5px;
    }
  }
}
</style>
